import axios from "axios"
import {Tenant, TenantResponse} from "../../dtos/tenantResponse"
import {LocalStorageHandler} from "../../utils/localStorageHandler"
import {getAxiosConfigWithAuth} from "../../utils/auth"
export default class TenantService {
	defaultTenant = {
		id: "VP-IE-PROD",
		defaultCulture: "en-IE",
		merchantId: "vistaprint",
		defaultCountryCode: "IE",
	}
	siteTenantEndpoint = `${process.env.REACT_APP_TENANT_URL}/tenants`
	tenantFilter =
		process.env.REACT_APP_CARE_CONSOLE === "https://care-console.care.vpsvc.com" ? "PROD" : "DEV"
	public async getTenantDetails(
		tenantId: string,
		tenants: TenantResponse[]
	): Promise<TenantResponse> {
		try {
			if (!tenants || tenants.length === 0) {
				tenants = await this.getTenants()
			}
			const filtredTenants = tenants.filter((tenant) => tenant.id === tenantId)
			if (filtredTenants.length > 0) {
				return filtredTenants[0]
			} else {
				try {
					//Trying with order mngmnt endpoint for the cases tenant is not there in the site-tenant
					const {data} = await axios.get(
						`${process.env.REACT_APP_TENANT_SERVICE_URL}/tenants/${tenantId}?requestor=care-customer-ui`,
						getAxiosConfigWithAuth()
					)
					const tenant = data.tenant
					const tenantValue = {
						id: tenant.id,
						defaultCulture: tenant.defaultCulture,
						merchantId: tenant.pricingOptions.merchantId,
						defaultCountryCode: tenant.cartOptions.defaultCountryCode,
					}

					tenants.push(tenantValue)
					LocalStorageHandler.saveData(this.siteTenantEndpoint + this.tenantFilter, tenants)
					return tenantValue
				} catch {
					return this.defaultTenant
				}
			}
		} catch (error) {
			return this.defaultTenant
		}
	}

	async getTenants(): Promise<Array<TenantResponse>> {
		let tenants = LocalStorageHandler.getData(
			this.siteTenantEndpoint + this.tenantFilter
		) as TenantResponse[]
		if (tenants) {
			return tenants
		} else {
			tenants = await axios
				.get(this.siteTenantEndpoint)
				.then((res) => {
					return (res.data as Array<Tenant>)
						.filter((tenant) => tenant.id.includes(this.tenantFilter))
						.map((tenant) => {
							return {
								id: tenant.id,
								defaultCulture: tenant.defaultCulture,
								merchantId: tenant.pricingOptions.merchantId,
								defaultCountryCode: tenant.cartOptions.defaultCountryCode,
							}
						})
				})
				.catch((e) => {
					console.error("Error when getting the tenants data: " + e)
					return []
				})
			LocalStorageHandler.saveData(this.siteTenantEndpoint + this.tenantFilter, tenants)
		}

		return tenants
	}
}
